/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */

import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import { Box, Button, IconButton, Switch, FormControlLabel } from "@mui/material";
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import SyncIcon from '@mui/icons-material/Sync';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const Subscriptions = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const [rows, setRows] = useState([
        {
            id: 1,
            type: "Freemium",
            planName: "Free Starter",
            validity: "month",
            price: "$0",
            isActive: true,
            revenue: "AED 0",
            dashboard: ["Level 1"],
            aiHub: ["Trend Analysis"],
            aiSales: ["Dynamic Pricing"],
            benefits: [
                "Up to 10 products",
                "50 orders / month",
                "1 GB storage",
                "Up to 5,000 queries / month",
                "Basic analytics",
                "Email support",
                "Standard templates",
            ],
        },
        {
            id: 2,
            type: "Freemium",
            planName: "Basic",
            validity: "month",
            price: "$29",
            originalPrice: "$39",
            discount: "25% OFF",
            isDiscountActive: true,
            isActive: true,
            revenue: "AED 12,450",
            dashboard: ["Level 1", "Level 2", "Level 3"],
            aiHub: ["Trend Analysis", "Pricing Optimization", "SKU Profitability"],
            aiSales: ["Dynamic Pricing", "Cross-sell/Up-sell", "Personalized Discounts"],
            benefits: [
                "Up to 100 products",
                "500 orders / month",
                "5 GB storage",
                "Up to 10,000 queries / month",
                "Basic analytics",
                "Email support",
                "Standard templates",
                "Inventory management",
                "Order processing",
                "14-day free trial",
            ],
        },
        {
            id: 3,
            type: "Premium",
            planName: "Professional",
            validity: "month",
            price: "$79",
            originalPrice: "$99",
            discount: "Limited Time",
            isActive: true,
            revenue: "AED 66,050",
            dashboard: ["Level 1", "Level 2", "Level 3", "Level 4", "Level 5", "Level 6"],
            aiHub: ["Full Performance Hub", "Market Gap Analysis", "Return Rate Prediction"],
            aiSales: ["Full Optimization", "Smart Restock", "Lifecycle Prediction"],
            benefits: [
                "Unlimited products",
                "5000 orders / month",
                "50 GB storage",
                "Unlimited queries",
                "Advanced analytics",
                "Priority support",
                "Custom templates",
                "AI product descriptions",
                "Multi-channel selling",
                "+2 more features",
                "14-day free trial",
            ],
        },
    ]);

    const handleToggleSubscription = (id: number) => {
        setRows(prevRows =>
            prevRows.map(row =>
                row.id === id ? { ...row, isActive: !row.isActive } : row
            )
        );
    };





    return (
        <>
            <div className="main_title">
                <h1>Manage Subscriptions</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Subscriptions
                </p>
            </div>
            <div className="stats_boxes gap_m">
                {/* TOTAL SUBSCRIPTIONS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            128
                            <p>Total Subscriptions</p>
                        </h2>
                        <figure className="blue">
                            <SubscriptionsIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="data_bottom">
                        <p><span className="success">+32</span> Added (7 days)</p>
                    </div>
                </a>

                {/* SUBSCRIBED USERS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            117
                            <p>Subscribed Users</p>
                        </h2>
                        <figure className="sucess">
                            <GroupOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="data_bottom">
                        <p><span className="danger">+4.5%</span> Churn Rate <small>last 4 week</small></p>
                    </div>
                </a>

                {/* MRR */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            AED 78,500
                            <p>MRR <small style={{ fontSize: '11px', color: '#6b7280', display: 'block' }}>(Monthly Recurring revenue)</small></p>
                        </h2>
                        <figure className="warning">
                            <AccountBalanceWalletOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="data_bottom">
                        <p>
                            <span className="success">+18%</span> growth this month
                            <span style={{ color: '#6b7280', marginLeft: '10px' }}>+ 31% Trial...</span>
                        </p>
                    </div>
                </a>

                {/* UPSELL OPPORTUNITY */}
                <a className="cards ai_insight_card">
                    <div className="data_top" style={{ alignItems: 'flex-start' }}>
                        <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', gap: '5px', marginBottom: '8px' }}>
                                <LightbulbOutlinedIcon sx={{ color: '#d97706', fontSize: 24 }} />
                                <TrendingUpIcon sx={{ color: '#6b7280', fontSize: 24 }} />
                            </div>
                            <h3 style={{ fontSize: '15px', fontWeight: 600, margin: '0 0 5px 0' }}>Basic Plan Upsell Opportunity:</h3>
                            <p style={{ fontSize: '13px', color: '#6b7280', margin: '0 0 10px 0' }}>+18% upgrade likelihood in 30 days</p>
                            <span style={{ color: '#3b82f6', fontSize: '13px', fontWeight: 600, display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                Plan Details <ChevronRightIcon sx={{ fontSize: 16 }} />
                            </span>
                        </div>
                        <figure className="blue" style={{ width: '45px', height: '45px', minWidth: '45px' }}>
                            <SyncIcon />
                        </figure>
                    </div>
                </a>

            </div>
            <div className="table_flex mt_20">
                <div className="lt">

                    <div className="cards subscription_cards ">
                        {/* Header */}
                        <div className="table_header" style={{ flexWrap: 'wrap', gap: '10px' }}>
                            <div className="left_s" style={{ flex: 1, gap: '10px' }}>
                                <Box className="search_box" style={{ minWidth: '200px' }}>
                                    <SearchBar
                                        searchTerm={searchTerm}
                                        setDebouncedSearchTerm={setSearchTerm}
                                        placeholder="Search Subscription Plans..."
                                    />
                                </Box>
                                <div className="form" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    <div className="control_group">
                                        <select style={{ minWidth: '130px' }}>
                                            <option>dd--yyy</option>
                                        </select>
                                    </div>
                                    <div className="control_group">
                                        <select style={{ minWidth: '130px' }}>
                                            <option>Active</option>
                                            <option>Inactive</option>
                                        </select>
                                    </div>
                                    <div className="control_group">
                                        <select style={{ minWidth: '130px' }}>
                                            <option>All Plans</option>
                                            <option>Premium</option>
                                            <option>Free</option>
                                        </select>
                                    </div>
                                    <div className="control_group">
                                        <Button className="btn btn_grey sm" style={{ color: '#666' }}><span style={{ marginRight: '5px' }}>⚙</span> 1y Tenure</Button>
                                    </div>
                                    <div className="control_group">
                                        <Button className="btn btn_grey sm" style={{ color: '#666' }}>More v</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="right_s">
                                <Button
                                    variant="contained"
                                    className="btn btn_primary"
                                    onClick={() => navigate("/subscriptions/edit")}
                                >
                                    <AddIcon /> Add Subscription
                                </Button>
                            </div>
                        </div>

                        {/* Subscription Cards */}
                        <div className="subscription_grid">
                            {rows
                                .filter(
                                    (row) =>
                                        row.planName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        row.type.toLowerCase().includes(searchTerm.toLowerCase())
                                )
                                .map((row) => (
                                    <div className="subscription_card" key={row.id}>
                                        {/* Top */}
                                        <div className="card_top">
                                            <span className={`badge ${row.type.toLowerCase()}`}>
                                                {row.type}
                                            </span>

                                            {/* Discount Badge */}
                                            {/* @ts-ignore */}
                                            {row.isDiscountActive && (
                                                /* @ts-ignore */
                                                <span className="badge discount" style={{ background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca' }}>{row.discount}</span>
                                            )}

                                            <div className="actions">
                                                <Switch
                                                    size="small"
                                                    checked={row.isActive}
                                                    onChange={() => handleToggleSubscription(row.id)}
                                                    color="primary"
                                                />
                                                <IconButton onClick={() => navigate("/subscriptions/edit")}>
                                                    <img src="/static/images/edit2_icon.svg" />
                                                </IconButton>
                                                <IconButton>
                                                    <img src="/static/images/trash2_icon.svg" />
                                                </IconButton>
                                            </div>
                                        </div>

                                        {/* Content */}
                                        <h3 className="plan_name">{row.planName}</h3>

                                        <div className="price">
                                            {row.price}
                                            {/* @ts-ignore */}
                                            {row.originalPrice && <span style={{ textDecoration: 'line-through', fontSize: '14px', color: '#999', marginLeft: '5px' }}>{row.originalPrice}</span>}
                                            <span>/ {row.validity}</span>
                                        </div>

                                        <div className="plan_revenue">
                                            <span className="lbl">Revenue Gained:</span>
                                            <span className="val">{row.revenue}</span>
                                        </div>

                                        {/* Benefits */}
                                        <ul className="benefits">
                                            {row.benefits.map((b, i) => (
                                                <li key={i}>{b}</li>
                                            ))}
                                        </ul>

                                        <div className="ai_features_badge_container">
                                            {/* @ts-ignore */}
                                            {row.dashboard && <div className="feature_category">
                                                <span>Dashboard: {row.dashboard.join(", ")}</span>
                                            </div>}
                                            {/* @ts-ignore */}
                                            {row.aiHub && <div className="feature_category ai">
                                                <span>AI Hub: {row.aiHub.join(", ")}</span>
                                            </div>}
                                            {/* @ts-ignore */}
                                            {row.aiSales && <div className="feature_category ai">
                                                <span>Sales Opt: {row.aiSales.join(", ")}</span>
                                            </div>}
                                        </div>

                                        {/* Footer */}
                                        <div className="card_footer">
                                            <Button
                                                fullWidth
                                                className="btn btn_primary sm"
                                                onClick={() => navigate("/subscriptions/view")}
                                            >
                                                View Details
                                            </Button>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_panel">
                        <h4>AI Insights</h4>

                        {/* Revenue vs Cost Monitor */}
                        <div className="ai_alert success" style={{ background: '#f0fdf4', border: '1px solid #dcfce7' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'bold', color: '#166534' }}>
                                    <AccountBalanceWalletOutlinedIcon style={{ fontSize: 18 }} /> Revenue Optimization
                                </div>
                            </div>
                            <p style={{ fontSize: '12px', marginBottom: '10px', color: '#14532d' }}>
                                Subscription revenue is <b>3.5x</b> higher than service costs this month.
                            </p>
                            <Button fullWidth variant="contained" style={{ backgroundColor: '#fff', color: '#166534', textTransform: 'none', boxShadow: 'none', border: '1px solid #dcfce7', fontSize: '12px' }}>View Price Analysis</Button>
                        </div>

                        {/* Recommendation */}
                        <div className="ai_alert warning" style={{ display: 'block', borderLeft: '4px solid #d97706' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'bold', color: '#374151' }}>
                                    <span style={{ fontSize: '16px' }}>💡</span> Discount Strategy
                                </div>
                            </div>
                            <p style={{ fontSize: '12px', marginBottom: '15px', color: '#666' }}>
                                Recommend offering <b>20% Annual Discount</b> on "Basic" plan to reduce churn.
                            </p>
                        </div>

                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>

                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>

                        {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                    </div>
                </div>
            </div>

            {/* Insights Bar */}
            <div className="insights_bar mt_20">
                <div className="insight_item">
                    <h2 style={{ color: '#16a34a' }}>39% <span style={{ fontSize: '14px', color: '#374151', fontWeight: 'bold' }}>Trial → Paid Conversion</span></h2>
                    <p style={{ color: '#666', fontSize: '12px' }}>
                        96 Active Trials &nbsp;&nbsp;|&nbsp;&nbsp; 28 Upgraded
                    </p>
                </div>
                <div className="divider"></div>
                <div className="insight_item">
                    <h2 style={{ color: '#0891b2' }}>4% <span style={{ fontSize: '14px', color: '#374151', fontWeight: 'bold' }}>Upgrade / Downgrade</span></h2>
                    <p style={{ color: '#666', fontSize: '12px' }}>
                        @ 66 Active Trials
                    </p>
                </div>
                <div className="divider"></div>
                <div className="insight_item">
                    <h2 style={{ color: '#16a34a' }}>94% <span style={{ fontSize: '14px', color: '#374151', fontWeight: 'bold' }}>Plan Retention Rate</span></h2>
                    <p style={{ color: '#666', fontSize: '12px' }}>
                        ○ 34 Plan Retention rate
                    </p>
                </div>
                <div className="divider"></div>
                <div className="insight_item">
                    <h2 style={{ color: '#16a34a' }}>94% <span style={{ fontSize: '14px', color: '#374151', fontWeight: 'bold' }}>Plan Retention Rate</span> <span style={{ fontSize: '14px', color: '#16a34a' }}>↑</span></h2>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <p style={{ color: '#666', fontSize: '12px' }}>
                            <span style={{ color: '#16a34a' }}>↑ 23</span> upgraded
                        </p>
                        <div style={{ textAlign: 'right', fontSize: '11px', lineHeight: '1.2', display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <span style={{ color: '#16a34a', fontSize: '16px' }}>↗</span>
                            <div>
                                <b>Active Trials</b><br />
                                23 Upgraded
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Subscriptions;
